import React from 'react'

export default function Select({ label = "Label Name", width = "full", name = "Name",placeholder="placeholder", options = [],defaultValue="", ...props }) {
    return (
        <div className={`w-full px-3 sm:w-1/2`}>
            <div className="mb-5">
                <label
                    htmlFor={name}
                    className="mb-3 block text-base font-medium text-[#07074D]"
                >
                    {label}
                </label>
                <div className="relative">
                    <select defaultValue={defaultValue} className="block appearance-none w-full border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id={name} name={name} {...props}>
                        <option value={""}>{placeholder}</option>
                        {options.map((opt,i) => <option key={opt+i}>{opt}</option>)}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                    </div>
                </div>
            </div>
        </div>
    )
}
